export default function formatTimeFromDatetime (value) {
  if (value === undefined || value == null) { return '' }
  let returnVal = ''
  if (value !== null) {
    let date = Date
    date = new Date(value)
    returnVal = date.getHours().toString() + ':' + (date.getMinutes().toString().length === 1 ? '0' : '') + date.getMinutes().toString()
  }
  return returnVal
}
